import MenuIcon from '@mui/icons-material/Menu'
import React, { useCallback, useState } from 'react'
import { AdminFilterProvider } from './AdminFilterProvider'
import { AdminContainer, AdminContent, AdminMain, FilterBar } from './AdminLayout.styles'
import AdminSidebar from './AdminSidebar'
import { MenuButton } from './AdminSidebar.styles'
import DateRangeFilter from './DateRangeFilter'
import InternalDataToggle from './InternalDataToggle'

/**
 * Dedicated shell for the internal admin surface, deliberately separate from the
 * consumer trip layout/nav.
 *
 * Navigation is a column down the left ({@link AdminSidebar}); the global filters
 * sit in a bar directly above the content they scope, where they also keep the
 * horizontal room the date presets need. Both feed every admin view through
 * {@link AdminFilterProvider}.
 *
 * The drawer state lives here rather than in the sidebar because its trigger
 * belongs in the filter bar, on the other side of the layout.
 */
const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [drawerOpen, setDrawerOpen] = useState(false)
	const closeDrawer = useCallback(() => setDrawerOpen(false), [])

	return (
		<AdminFilterProvider>
			<AdminContainer>
				<AdminSidebar open={drawerOpen} onClose={closeDrawer} />
				<AdminMain>
					<FilterBar>
						<MenuButton
							type="button"
							aria-label={drawerOpen ? 'Close navigation' : 'Open navigation'}
							aria-expanded={drawerOpen}
							aria-controls="admin-nav"
							onClick={() => setDrawerOpen(current => !current)}
						>
							<MenuIcon />
						</MenuButton>
						<DateRangeFilter />
						<InternalDataToggle />
					</FilterBar>
					<AdminContent>{children}</AdminContent>
				</AdminMain>
			</AdminContainer>
		</AdminFilterProvider>
	)
}

export default AdminLayout
